// extracted by mini-css-extract-plugin
export default {"field-form":"FieldForm_field-form__WVnkG","checkbox-container":"FieldForm_checkbox-container__T240U","tag":"FieldForm_tag__4kdk5","checkbox-label":"FieldForm_checkbox-label__uIvCO"};